<template>
    <div class="about-mav">
        <p class="indent">Alcomet si pone come azienda socialmente responsabile ed efficiente, capace di offrire soluzioni innovative ai propri clienti e di fornire opportunità ai propri partner.</p>
        <p class="indent">I valori chiave che ci definiscono come azienda sono:</p>
        <div class="values-wrapper">
          <div class="value">
            <h3 class="strong">Lealtà </h3>
            <p>Essere un partner affidabile per i clienti che hanno riposto in noi la loro fiducia, offrendo loro il miglior servizio possibile e aiutandoli nella loro crescita</p>
          </div>
          <div class="value">
            <h3 class="strong">Responsabilità </h3>
            <p>Nel nostro comportamento verso la comunità locale e l’ambiente, i nostri clienti ed i nostri partner</p>
          </div>
          <div class="value">
            <h3 class="strong">Flessibilità </h3>
            <p>Nella nostra capacità di adattarci alle condizioni di un mercato dinamico e in continua evoluzione ed ai fabbisogni dei nostri clienti</p>
          </div>
          <div class="value">
            <h3 class="strong">Trasparenza </h3>
            <p>Nelle nostre azioni, nella nostra strategia economica e nella nostra politica aziendale, rispettando i più alti standard di onestà e professionalità.</p>
          </div>
        </div>
        <app-share-button></app-share-button>
    </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
export default {
  components: {
    appShareButton: ShareButton
  }
};
</script>

<style scoped>
.about-mav p {
  font-size: 19px;
  line-height: 32px;
  margin: 15px auto;
  text-align: justify;
  width: 60%;
}
.values-wrapper {
  display: flex;
  flex-wrap: wrap;
  margin: 30px auto 0;
  width: 1000px;
}
.value {
  align-items: center;
  border-radius: 6px;
  background-color: #008bc2;
  display: flex;
  padding: 20px;
  flex-direction: column;
  margin: 15px 0;
  width: calc(50% - 15px);
}
.value:nth-child(odd) {
  margin-right: 30px;
}
.value:nth-child(3),
.value:nth-child(4) {
  margin-bottom: 0;
}
.value h3 {
  color: #fff;
  font-size: 24px;
  text-align: center;
  margin: 15px 0;
}
.value > p {
  color: #fff;
  margin: 0;
  padding: 15px;
  width: 100%;
}
@media screen and (max-width: 1440px) {
  .values-wrapper {
    width: 800px;
  }
}
@media screen and (max-width: 1280px) {
  .values-wrapper {
    width: 80%;
  }
}
@media screen and (max-width: 1000px) {
  .about-mav p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
  .values-wrapper {
    width: 100%;
    padding: 0 30px;
  }
  .value {
    padding: 20px;
  }
  .value h3 {
    font-size: 20px;
    margin-top: 0;
  }
  .value p {
    font-size: 16px;
    line-height: 24px;
    margin: 0;
    padding: 0;
  }
}
@media screen and (max-width: 800px) {
  .value p {
    font-size: 14px;
    line-height: 20px;
  }
}
@media screen and (max-width: 600px) {
  .about-mav .value {
    width: 100%;
    margin: 10px 0;
  }
  .about-mav .value:last-child {
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/about/MissionAndValues.vue